import React from 'react'
import styled from 'styled-components'
import SpeedIcon from '../../icons/IconLib/TruckIcon'

export interface SpeedBadgeProps {
  active?: boolean
  className?: string
}

export const SpeedBadge: React.FC<SpeedBadgeProps> = ({
  active = false,
  className,
}) => (
  <Root
    $active={active}
    className={className}
    aria-label={active ? 'urgent' : 'standard'}
  >
    <SpeedIcon color='currentColor' />
  </Root>
)

export default SpeedBadge

const Root = styled.span<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.375rem;
  height: 1.375rem;
  font-size: 1rem;
  line-height: 1;
  color: ${({ $active, theme }) =>
    $active ? 'tomato' : theme.colors.line};
  flex-shrink: 0;
`
